module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/arr_rec-0a740ed7b7b3c225d7ae4db7b055a17e.svg";